/* global axios */
import ApiClient from './ApiClient';

class KanbanViewsAPI extends ApiClient {
  constructor() {
    super('custom_filters', { accountScoped: true });
  }

  getKanbanViews() {
    return axios.get(`${this.url}?filter_type=kanban`);
  }

  deleteKanbanView(id) {
    return axios.delete(`${this.url}/${id}?filter_type=kanban`);
  }
}

export default new KanbanViewsAPI();
